var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.5,
    r: 3,
    stroke: "#00A991",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 21.5H14.2222C17.3433 21.5 18.9038 21.5 20.0248 20.7646C20.51 20.4462 20.9267 20.0371 21.251 19.5607C22 18.4601 22 16.9279 22 13.8636C22 10.7994 22 9.26721 21.251 8.1666C20.9267 7.69014 20.51 7.28104 20.0248 6.96268C19.3044 6.49013 18.4027 6.32123 17.022 6.26086C16.3631 6.26086 15.7959 5.77068 15.6667 5.13636C15.4728 4.18489 14.6219 3.5 13.6337 3.5H10.3663C9.37805 3.5 8.52715 4.18489 8.33333 5.13636C8.20412 5.77068 7.63685 6.26086 6.978 6.26086C5.59733 6.32123 4.69555 6.49013 3.97524 6.96268C3.48995 7.28104 3.07328 7.69014 2.74902 8.1666C2 9.26721 2 10.7994 2 13.8636C2 16.9279 2 18.4601 2.74902 19.5607C3.07328 20.0371 3.48995 20.4462 3.97524 20.7646C5.09624 21.5 6.65675 21.5 9.77778 21.5Z",
    stroke: "#00A991",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5H18",
    stroke: "#00A991",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bb04d133798ec9398f202a94233f1f43.svg";
export { ForwardRef as ReactComponent };